export default {
  FORWARDER: 'forwarder',
  INPUT_PROFILE: 'forwarder#input-profile',
};
